export const ERUConfigurationFormTabNames = {
	configuration: 'Configuration',
	carriersData: 'Carriers data',
} as const;

export const RU_CONFIGURATION_FORM_AREAS = `
	"name vlanId"
	"ruMacAddress duMacAddress"
	"submitButtons submitButtons"
`;

export const RU_CARRIER_DATA_FORM_AREAS = `
	"mimoMode ."
	"frequency nrafrcn"
	"channelBandwidth transmissionGain"
	"submitButtons submitButtons"
`;

export const ERUConfigurationFormFields = {
	name: 'Name',
	vlanId: 'vlanId',
	ruMacAddress: 'ruMacAddress',
	duMacAddress: 'duMacAddress',
	mimoMode: 'mimoMode',
	frequency: 'frequency',
	nrafrcn: 'nrafrcn',
	channelBandwidth: 'channelBandwidth',
	transmissionGain: 'transmissionGain',
} as const;

export const RU_FIELDS_TO_TEST = [
	ERUConfigurationFormFields.name,
	ERUConfigurationFormFields.vlanId,
	ERUConfigurationFormFields.ruMacAddress,
	ERUConfigurationFormFields.duMacAddress,
];

export const ERUConfigurationFormFieldsLabel = {
	name: 'Name',
	vlanId: 'VLAN ID',
	ruMacAddress: 'RU MAC Address',
	duMacAddress: 'DU MAC Address',
	mimoMode: 'MIMO Mode',
	frequency: 'Frequency',
	nrafrcn: 'NR ARFCN',
	channelBandwidth: 'Channel Bandwidth',
	transmissionGain: 'Transmission Gain',
} as const;

export const VLAN_ID_TOOLTIP = 'Control and User plane VLAN ID for communication between O-RU and O-DU';
export const CHANNEL_BANDWIDTH_TOOLTIP = 'Width of carrier';
export const TRANSMISSION_GAIN_TOOLTIP = 'Value applicable to each array element carrier belonging to array carrier';

export const MIN_VLAN = 0;
export const MAX_VLAN = 4094;
export const MIN_CONFIGURATION_HZ = 0;
export const MAX_CONFIGURATION_HZ = 1e11;
export const MIN_DB = 0;
export const MAX_DB = 100;
export const MAX_MAC_LENGTH = 17;
